import { action } from 'typesafe-actions'
import { OrganiserActionTypes } from './types'
import { IOrganiserProfile } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(OrganiserActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IOrganiserProfile[]) => action(OrganiserActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(OrganiserActionTypes.LIST_ERROR, errors)
export const listClear = () => action(OrganiserActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(OrganiserActionTypes.SELECT, id)
export const selectedData = () => action(OrganiserActionTypes.SELECTED)
export const selectedClear = () => action(OrganiserActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IOrganiserProfile) => action(OrganiserActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IOrganiserProfile) => action(OrganiserActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(OrganiserActionTypes.CREATE_ERROR, errors)

// // Read
// export const readRequest = (data: IOrganiserProfile) => action(OrganiserActionTypes.READ_REQUEST, data)
// export const readSuccess = (data: IOrganiserProfile) => action(OrganiserActionTypes.READ_SUCCESS, data)
// export const readError = (message: string) => action(OrganiserActionTypes.READ_ERROR, message)

// Update
export const updateRequest = (keyValues: any) => action(OrganiserActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IOrganiserProfile) => action(OrganiserActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(OrganiserActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IOrganiserProfile) => action(OrganiserActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(OrganiserActionTypes.DELETE_SUCCESS, id)  // Return deleted organiser id to remove from state
export const deleteError = (errors: any) => action(OrganiserActionTypes.DELETE_ERROR, errors)
